// extracted by mini-css-extract-plugin
module.exports = {"user-settings":"Settings_user-settings__3TA-W","user-settings__block":"Settings_user-settings__block__3y0EY"};